"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataPropValidator = void 0;
const dataPropValidator = props => {
  if (!props.src && !props.tree) {
    return new Error('One among "src" or "tree" prop must be provided');
  }
};
exports.dataPropValidator = dataPropValidator;